import React, { FC, useMemo } from 'react';
import { useTranslate } from '@/translations';
import { Button } from 'antd';
import { CustomColumns, CustomTable } from '@/ui/components';
import { PointInTimeReport } from '@/types';
import { PointInTimeReportsDataGridProps } from './types';

export const PointInTimeReportsDataGrid: FC<
  PointInTimeReportsDataGridProps
> = ({ dataSource }) => {
  const { t } = useTranslate();

  const columns: CustomColumns<PointInTimeReport> = useMemo(
    () => [
      {
        dataIndex: 'date',
        title: 'Date',
        width: 180,
      },
      {
        dataIndex: 'event',
        title: 'Event',
      },
      {
        dataIndex: 'image',
        width: 220,
        render: (value) => (
          <a
            href={value}
            download
            target="_blank"
            rel="noreferrer"
            aria-label="View"
          >
            <Button type="primary">{t('viewReport')}</Button>
          </a>
        ),
      },
    ],
    [t],
  );

  return <CustomTable dataSource={dataSource} columns={columns} rowKey="id" />;
};
